import Experience from "./hybrid-towers/Experience";

new Experience({
  hotspots: {
    hybrid: document.querySelectorAll(".hotspot[data-type='hybrid']"),
    growth: document.querySelectorAll(".hotspot[data-type='growth']"),
    tower: document.querySelectorAll(".hotspot[data-type='tower']"),
    towerInterior: document.querySelectorAll(".hotspot[data-type='tower-interior']"),
    cameraCoverage: document.querySelectorAll(".hotspot[data-type='camera-coverage']")
  },
  labels: document.querySelectorAll(".label"),
  drawers: document.querySelectorAll(".drawer"),
});
